@if (featurePermission) {
    <div class="agpr-product-features">
        <div class="agpr-product-features-headerContainer">
            <h2 class="agpr-product-features-header-permission">{{header | localize}}</h2>
        </div>
        <div class="agpr-product-features-container">
            @for (subItem of subItems; track subItem.id) {
                <agpr-product-feature-item
                    [id]="id + '.' + featureId + '.' + subItem.id"
                    [header]="subItem.header"
                    [message]="subItem.message"
                    [buttonTitle]="subItem.hasPermission ? subItem.buttonTitle.provisioned : subItem.buttonTitle.notProvisioned"
                    [headerIcon]="subItem.headerIcon"
                    [externalUrl]="subItem.externalUrl"
                    [buttonUrl]="subItem.hasPermission ? subItem.buttonUrl.provisioned : subItem.buttonUrl.notProvisioned"
                    [hasPermission]="subItem.hasPermission"
                >
                </agpr-product-feature-item>
            }
        </div>
    </div>
} @else {
    <div class="agpr-product-features-noPermission"
        [ngClass]="{
            'agpr-product-features-noPermission--light': !isWhiteLabeledBrand,
            'agpr-product-features-noPermission--primary': isWhiteLabeledBrand
        }"
    >
        <div
            class="agpr-product-features-headerContainer"
            [ngClass]="{'agpr-product-features-headerContainer-noPermission' : !featurePermission}"
        >
            <span class="fa-solid fa-lock agpr-product-features-headerIcon"></span>
            <h2 class="agpr-product-features-header-noPermission">{{header | localize}}</h2>
        </div>
        <div class="agpr-product-features-upsell">
            <div class="agpr-product-features-upsell-message">{{upsellMessage | localize}}</div>
            <agpr-button
                [id]="id +'.'+ featureId + '.unlock'"
                [label]="'Core.navigation.unlock'"
                [tooltip]="'Core.navigation.unlock'"
                tooltipPosition="top"
                [style]="buttonTypes.primary"
                class="agpr-product-features-upsell-button"
                (click)="openUpsellInfoPanel(featureId)"
            ></agpr-button>
        </div>
    </div>
}
